<template>
  <div>
    <el-card class="box-card" v-if="isBoxCard">
             <p>中运交投</p>
             <p>请通过短信中的链接 <span class="blue">进行开户，手机号：{{info.mobile}}</span></p>
             
             <div class="card-btn">
                <button @click="ispopup()">取消</button> 
                <button @click="getCode()">重发短信({{timepiece}}s)</button>
                <button @click="openAnAccount()">
                    已完成开户
                </button>
             </div>

        </el-card>
        <shroff v-if = "isshroff"  @fsisshroff = "fsisshroff()"></shroff>
  </div>
</template>

<script>
import shroff from './shroff.vue'
export default {
   data(){
    return {
        isshroff:false,
        timepiece:10,
        isBoxCard:true
    }
   },
   components:{
     shroff,
   },
   props:['FSiscard','getaccount','FSisAccount','info'],
   created(){
   this.counter()
  
   },
   methods:{
    openAnAccount(){
        this.$emit('FSisAccount')
    },
    fsisshroff(r){
       this.isshroff = r
    },
    counter(){
        this.time = setInterval(()=>{
        this.timepiece -- 
        if(this.timepiece <= 0){
            this.timepiece = 0
            clearInterval(this.time)
        }
    },1000)
    },

    ispopup(){
        this.$emit('FSiscard')
    },
    getCode(){
        if(this.timepiece > 0){
            this.$message({
                message: '请60秒后在发送',
                type: 'warning'
            });
        }else{
            this.timepiece = 10
            this.counter()
            this.$emit('getaccount')
        }
    }
   }
}
</script>

<style lang="scss">
.box-card{
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 500px;
    height: 380px;
    text-align: center;
    .p2{
        margin: 20px 0;
    }
    .footer-btn{
        height: 50px;
        width: 100%;
        display: flex;
        margin: 60px 0;
        justify-content: space-around;
        }
    p:nth-child(2){
        margin: 130px 0;
        span{
            color: blue;
        }
        
    }
}
.card-btn{
    display: flex;
    width: 82%;
    margin: 0 auto;
    justify-content: space-between;
    button{
        border: none;
        background: #3B46C4;
        width: 90px;
        height: 40px;
        border-radius: 4px;
        font-weight: 900;
        color: #fff;
    }
}

  
</style>